import { useCallback, useEffect, useState } from 'react';
import { fg } from '@atlassian/jira-feature-gating';
import type { Product } from '@atlassian/edition-awareness';
import {
	fetchEditionAwarenessPillDismissed,
	setEditionAwarenessPillDismissed,
} from '../../utils/index.tsx';

export const useIsEditionAwarenessPillDismissed = (product: Product | undefined) => {
	const [hasFetched, setHasFetched] = useState(false);
	const [isDismissed, setIsDismissed] = useState(true);

	const canDismiss =
		product === 'jira-product-discovery'
			? fg('upsell_edition_awareness_jpd_fg')
			: fg('edition_awareness_upsell_jira_ab_fg');

	useEffect(() => {
		if (canDismiss) {
			fetchEditionAwarenessPillDismissed().then((result) => {
				// if result is undefined, it means the call failed and we can't be certain if the user dismissed the pill or not
				if (result !== undefined) {
					setIsDismissed(!!result);
					setHasFetched(true);
				}
			});
		}
	}, [canDismiss]);

	const handleDismiss = useCallback((): void => {
		if (canDismiss) {
			setIsDismissed(true);
			setEditionAwarenessPillDismissed(true);
		}
	}, [canDismiss]);

	return { hasFetched, isDismissed, handleDismiss };
};
